module.exports = __webpack_public_path__ + "static/media/Tusass_2026_PDF.d7670654.pdf";